module.exports = __webpack_public_path__ + "img/lottba4.5416ac49.png";